<template>
    <div>
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                v-if="model"
                ref="RkmForm"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.data.end"
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            :start-validations="validations.data.start"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.data"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-multiselect
                            :disabled="!model.data.start || !model.data.end"
                            :options="form.unidades"
                            :select-limit="null"
                            @update:dropdownClosed="handleUnidadeDropdownClosed"
                            label="Unidade"
                            option-name-key="nomeFantasia"
                            option-text-selecteds="unidade selecionada"
                            v-model="model.unidades"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-multiselect
                            :disabled="!model.data.start || !model.data.end"
                            :options="form.servicosTipos"
                            :select-limit="null"
                            @update:dropdownClosed="handleServicoTipoDropdownClosed"
                            label="Tipo de serviço"
                            option-name-key="descricao"
                            option-text-selecteds="tipo de serviço selecionado"
                            v-model="model.servicosTipos"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-multiselect
                            :disabled="!model.data.start || !model.data.end"
                            :options="form.processamentosStatus"
                            :select-limit="null"
                            @update:dropdownClosed="handleProcessamentoStatusDropdownClosed"
                            label="Status do processamento"
                            option-name-key="descricao"
                            option-text-selecteds="status do processamento selecionado"
                            v-model="model.processamentosStatus"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-multiselect
                            :disabled="!model.data.start || !model.data.end"
                            :options="form.protocolos"
                            :select-limit="null"
                            @update:dropdownClosed="handleProtocoloDropdownClosed"
                            label="Protocolo"
                            option-name-key="protocolo"
                            option-text-selecteds="protocolo selecionado"
                            v-model="model.protocolos"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-multiselect
                            :disabled="!model.data.start || !model.data.end"
                            :options="form.lotes"
                            :select-limit="null"
                            label="Lote"
                            option-name-key="lote"
                            option-text-selecteds="lote selecionado"
                            v-model="model.lotes"
                            value-field="lote"
                        />
                    </rkm-col>

                    <rkm-col
                        class="text-nowrap"
                        cols="auto"
                    >
                        <rkm-button
                            :disabled="!model.data.start || !model.data.end"
                            @click="handleBuscarClick"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :disabled="!model.data.start || !model.data.end"
                            @click="handleLimparClick"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="handleTodosClick"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedColumns"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="itens.length === 0"
                    @click="handleImprimirClick"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="itens.length === 0"
                    @click="handleExportarClick"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fields"
                :items="itens"
                hide-filters
                sort-by="dataProtocolo"
                sort-desc
            >
                <template v-slot:cell(inconsistencias)="{item}">
                    <template v-if="item.respostas && item.respostas.length > 0">
                        <span
                            v-for="(resposta, index) in item.respostas"
                            :key="index"
                        >
                            <strong>Código:</strong> {{resposta.codigo ? resposta.codigo : 'Não informado'}}, <strong>Valor rejeitado:</strong> {{resposta.valorRejeitado ? resposta.valorRejeitado : 'Não informado'}}, <strong>Descrição:</strong> {{resposta.descricao ? resposta.descricao : 'Não informado'}}
                        </span>
                    </template>
                    <template v-else>
                        -
                    </template>
                </template>
            </rkm-table>
        </rkm-area>

        <rkm-area
            v-if="itens.length > 0"
            no-margin-top
            title="Totais"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :value="totalizadores.quantidadeTotalEnvios"
                        disabled
                        label="Quantidade total de envios"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :value="totalizadores.quantidadeTotalInconsistencias"
                        disabled
                        label="Quantidade total de inconsistências"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :value="totalizadores.quantidadeTotal"
                        disabled
                        label="Quantidade total"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>
// Mixins.
import {error, repository, stringCase, object} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        fields() {
            return this.columns.filter(column => (column.fixed || false) || this.selectedColumns.includes(column.key))
        },
        optionalColumns() {
            return this.columns.filter(column => !(column.fixed || false))
        },
        validations() {
            return {
                data: {
                    start: { required: true },
                    end: { required: true },
                }
            }
        },
    },
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.integracao.bnafar'),
            exportacao: this.getConectaSusRepository('exportacao.integracao'),
            relatorioEnvio: this.getConectaSusRepository('integracao.bnafar.relatorioEnvio'),
        }
    },
    data: () => ({
        additionals: null,
        columns: [
            {key: 'dataProtocolo', label: 'Data', fixed: true},
            {key: 'servicoTipoDescricao', label: 'Tipo de serviço', fixed: true},
            {key: 'processamentoStatusDescricao', label: 'Status do processamento', fixed: true},
            {key: 'protocolo', label: 'Protocolo'},
            {key: 'inconsistencias', label: 'Inconsistências'},
        ],
        form: null,
        indeterminate: false,
        itens: [],
        model: null,
        others: {moment},
        selectedAll: true,
        selectedColumns: [
            'protocolo',
        ],
        totalizadores: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioEnvio.create()
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUnidadeDropdownClosed() {
            this.form.servicosTipos = []
            this.form.processamentosStatus = []
            this.form.protocolos = []
            this.form.lotes = []
            this.model.servicosTipos = []
            this.model.processamentosStatus = []
            this.model.protocolos = []
            this.model.lotes = []

            this.itens = []

            const request = {
                listar: 'servicos-tipos',
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                unidades: this.model.unidades,
            }

            this.setLoading()

            this.repositories.relatorioEnvio.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.servicosTipos = Object.assign(response.data.servicosTipos)
                    this.form.processamentosStatus = Object.assign(response.data.processamentosStatus)
                    this.form.protocolos = Object.assign(response.data.protocolos)
                    this.form.lotes = Object.assign(response.data.lotes)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleServicoTipoDropdownClosed() {
            this.form.processamentosStatus = []
            this.form.protocolos = []
            this.form.lotes = []
            this.model.processamentosStatus = []
            this.model.protocolos = []
            this.model.lotes = []

            this.itens = []

            const request = {
                listar: 'processamentos-status',
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                unidades: this.model.unidades,
                servicosTipos: this.model.servicosTipos,
            }

            this.setLoading()

            this.repositories.relatorioEnvio.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.processamentosStatus = Object.assign(response.data.processamentosStatus)
                    this.form.protocolos = Object.assign(response.data.protocolos)
                    this.form.lotes = Object.assign(response.data.lotes)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleProcessamentoStatusDropdownClosed() {
            this.form.protocolos = []
            this.form.lotes = []
            this.model.protocolos = []
            this.model.lotes = []

            this.itens = []

            const request = {
                listar: 'protocolos',
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                unidades: this.model.unidades,
                servicosTipos: this.model.servicosTipos,
                processamentosStatus: this.model.processamentosStatus,
            }

            this.setLoading()

            this.repositories.relatorioEnvio.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.protocolos = Object.assign(response.data.protocolos)
                    this.form.lotes = Object.assign(response.data.lotes)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleProtocoloDropdownClosed() {
            this.form.lotes = []
            this.model.lotes = []

            this.itens = []

            const request = {
                listar: 'lotes',
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                unidades: this.model.unidades,
                servicosTipos: this.model.servicosTipos,
                processamentosStatus: this.model.processamentosStatus,
                protocolos: this.model.protocolos,
            }

            this.setLoading()

            this.repositories.relatorioEnvio.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.lotes = Object.assign(response.data.lotes))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleBuscarClick() {
            this.setLoading()

            const request = {
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                unidades: this.model.unidades,
                servicosTipos: this.model.servicosTipos,
                processamentosStatus: this.model.processamentosStatus,
                protocolos: this.model.protocolos,
                lotes: this.model.lotes,
            }

            this.repositories.relatorioEnvio.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data }) => {
                    this.itens = data.protocolos
                    this.totalizadores = data.totalizadores
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleLimparClick() {
            this.form.servicosTipos = []
            this.form.processamentosStatus = []

            this.model.data = {
                start: null,
                end: null,
            }

            this.form.unidades = []
            this.form.servicosTipos = []
            this.form.processamentosStatus = []
            this.form.protocolos = []
            this.form.lotes = []
            this.model.unidades = []
            this.model.servicosTipos = []
            this.model.processamentosStatus = []
            this.model.protocolos = []
            this.model.lotes = []

            this.itens = []
        },
        handleTodosClick(selected) {
            this.selectedColumns = selected ? this.optionalColumns.map(c => c.key) : []
        },
        handleImprimirClick() {
            this.setLoading()

            const request = {
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                unidades: this.model.unidades,
                servicosTipos: this.model.servicosTipos,
                processamentosStatus: this.model.processamentosStatus,
                protocolos: this.model.protocolos,
                lotes: this.model.lotes,
                selectedColumns: this.fields.map(field => ({
                    class: field.class,
                    key: this.camelToSnake(field.key),
                    label: field.label,
                })),
            }

            this.repositories.impressao.relatorioEnvio(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleExportarClick() {
            this.setLoading()

            const request = {
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                unidades: this.model.unidades,
                servicosTipos: this.model.servicosTipos,
                processamentosStatus: this.model.processamentosStatus,
                protocolos: this.model.protocolos,
                lotes: this.model.lotes,
                selectedColumns: this.fields.map(field => ({
                    class: field.class,
                    key: this.camelToSnake(field.key),
                    label: field.label,
                })),
            }

            this.repositories.exportacao.bnafarRelatorioEnvio(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mounted() {
        this.load()
    },
    mixins: [error, repository, stringCase, object],
    watch: {
        'model.data': {
            deep: true,
            handler(value) {
                this.form.unidades = []
                this.form.servicosTipos = []
                this.form.processamentosStatus = []
                this.form.protocolos = []
                this.form.lotes = []
                this.model.unidades = []
                this.model.servicosTipos = []
                this.model.processamentosStatus = []
                this.model.protocolos = []
                this.model.lotes = []

                this.itens = []

                if (value.start === null || value.end === null)  {
                    return
                }

                const request = {
                    listar: 'unidades',
                    data: {
                        start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                        end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                    },
                }

                this.setLoading()

                this.repositories.relatorioEnvio.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.unidades = Object.assign(response.data.unidades)
                        this.form.servicosTipos = Object.assign(response.data.servicosTipos)
                        this.form.processamentosStatus = Object.assign(response.data.processamentosStatus)
                        this.form.protocolos = Object.assign(response.data.protocolos)
                        this.form.lotes = Object.assign(response.data.lotes)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
        selectedColumns(value) {
            this.indeterminate = value.length > 0 && value.length != this.optionalColumns.length
            this.selectedAll = value.length > 0 && value.length == this.optionalColumns.length
        },
    },
}
</script>

<style scoped>
.dropdown >>> .auto-scroll {
    max-height: 400px;
    overflow-y: auto;
    width: 300px;
}
</style>